export const testIDs = {
    common: {
        container: "common-container",
    },
    overview: {
        headings: {
            tasks: "overview-heading-tasks",
            favourites: "overview-heading-favourites",
            insights: "overview-heading-insights",
        },
        tasks: {
            certificatesExpiringIn30Days: "overview-tasks-certificatesExpiringIn30Days",
            pendingCertificateSearch: "overview-tasks-pendingCertificateSearch",
            customersMissingCertificates: "overview-tasks-customersMissingCertificates",
            addSignature: "overview-tasks-addSignature",
            defineExemption: "overview-tasks-defineExemption",
        },
        favourites: {
            addCustomer: "overview-favourites-addCustomer",
            addVendor: "overview-favourites-addVendor",
            viewAllCustomers: "overview-favourites-viewAllCustomers",
            viewAllVendors: "overview-favourites-viewAllVendors",
            addCertificate: "overview-favourites-addCertificate",
            requestCertificates: "overview-favourites-requestCertificates",
            viewAllCertificates: "overview-favourites-viewAllCertificates",
            viewAllVendorCertificates: "overview-favourites-viewAllVendorCertificates",
            reports: "overview-favourites-reports",
            retail: "overview-favourites-retail",
            jobs: "overview-favourites-jobs",
        },
    },
    managedServices: {
        tabs: {
            burnup: "ms-tab-burnup",
            diagnostics: "ms-tab-diagnostics",
        },
        rules: {
            tab: "ms-tab-rules",
            root: "ms-rules",
            scopeForm: "ms-rules-scope-form",
            scopeCompany: "ms-rules-scope-company",
            summaryStrip: "ms-rules-summary",
            publishedVersion: "ms-rules-published-version",
            editor: "ms-rules-editor",
            editorToggle: "ms-rules-editor-toggle",
            editorText: "ms-rules-editor-text",
            editorSave: "ms-rules-editor-save",
            editorPublish: "ms-rules-editor-publish",
            editorProblems: "ms-rules-editor-problems",
            editorError: "ms-rules-editor-error",
            editorMessage: "ms-rules-editor-message",
            unpublishedNotice: "ms-rules-unpublished",
            pendingDraftNotice: "ms-rules-pending-draft",
            notOnThisPodNotice: "ms-rules-not-on-this-pod",
            history: "ms-rules-history",
            historyToggle: "ms-rules-history-toggle",
            historyRow: "ms-rules-history-row",
            historyRestore: "ms-rules-history-restore",
            historyError: "ms-rules-history-error",
            historyMessage: "ms-rules-history-message",
            historyCompare: "ms-rules-history-compare",
            diff: "ms-rules-diff",
            diffChange: "ms-rules-diff-change",
            diffIdentical: "ms-rules-diff-identical",
            draftDiff: "ms-rules-draft-diff",
            draftDiffHide: "ms-rules-draft-diff-hide",
            draftDiffError: "ms-rules-draft-diff-error",
            newForm: "ms-rules-new-form",
            newFormToggle: "ms-rules-new-form-toggle",
            newFormTemplate: "ms-rules-new-form-template",
            newFormCreate: "ms-rules-new-form-create",
            newFormError: "ms-rules-new-form-error",
            newFormEmpty: "ms-rules-new-form-empty",
            newCompany: "ms-rules-new-company",
            newCompanyToggle: "ms-rules-new-company-toggle",
            newCompanyAccount: "ms-rules-new-company-account",
            newCompanyPick: "ms-rules-new-company-pick",
            newCompanyCreate: "ms-rules-new-company-create",
            newCompanyError: "ms-rules-new-company-error",
            newCompanyEmpty: "ms-rules-new-company-empty",
            newCompanyNoAccounts: "ms-rules-new-company-no-accounts",
            modeView: "ms-rules-mode-view",
            modeEdit: "ms-rules-mode-edit",
            modeSellerAliases: "ms-rules-mode-seller-aliases",
            editLayer: "ms-rules-edit-layer",
            editEmpty: "ms-rules-edit-empty",
            editScopeNote: "ms-rules-edit-scope-note",
            viewScopeNote: "ms-rules-view-scope-note",
            overrideContext: "ms-rules-override-context",
            editThisRule: "ms-rules-edit-this-rule",
            layerTag: "ms-rules-layer-tag",
            formScopeTag: "ms-rules-form-scope-tag",
            loadError: "ms-rules-load-error",
            editRule: "ms-rule-edit",
            ruleEditor: "ms-rule-editor",
            ruleEditorText: "ms-rule-editor-text",
            ruleEditorSave: "ms-rule-editor-save",
            ruleEditorProblems: "ms-rule-editor-problems",
            ruleEditorError: "ms-rule-editor-error",
            ruleEditorMessage: "ms-rule-editor-message",
            search: "ms-rules-search",
            showTurnedOff: "ms-rules-show-turned-off",
            sectionToggle: "ms-rules-section-toggle",
            table: "ms-rules-table",
            row: "ms-rules-row",
            emptyState: "ms-rules-empty",
        },
        sellerAliases: {
            tab: "ms-tab-seller-aliases",
            root: "ms-seller-aliases",
            accountList: "ms-seller-aliases-account-list",
            accountRow: "ms-seller-aliases-account-row",
            loadError: "ms-seller-aliases-load-error",
            emptyState: "ms-seller-aliases-empty",
            newAccountToggle: "ms-seller-aliases-new-account-toggle",
            newAccount: "ms-seller-aliases-new-account",
            newAccountId: "ms-seller-aliases-new-account-id",
            newAccountName: "ms-seller-aliases-new-account-name",
            newAccountAliasInput: "ms-seller-aliases-new-account-alias-input",
            newAccountCreate: "ms-seller-aliases-new-account-create",
            newAccountError: "ms-seller-aliases-new-account-error",
            editor: "ms-seller-aliases-editor",
            editorAliasInput: "ms-seller-aliases-editor-alias-input",
            editorAliasChip: "ms-seller-aliases-editor-alias-chip",
            editorDontAcceptInput: "ms-seller-aliases-editor-dont-accept-input",
            editorDontAcceptChip: "ms-seller-aliases-editor-dont-accept-chip",
            editorValidate: "ms-seller-aliases-editor-validate",
            editorSave: "ms-seller-aliases-editor-save",
            editorPublish: "ms-seller-aliases-editor-publish",
            editorDiscard: "ms-seller-aliases-editor-discard",
            editorError: "ms-seller-aliases-editor-error",
            editorMessage: "ms-seller-aliases-editor-message",
            editorProblems: "ms-seller-aliases-editor-problems",
            historyToggle: "ms-seller-aliases-history-toggle",
            history: "ms-seller-aliases-history",
            historyRow: "ms-seller-aliases-history-row",
            historyRestore: "ms-seller-aliases-history-restore",
            historyCompare: "ms-seller-aliases-history-compare",
            historyError: "ms-seller-aliases-history-error",
            historyMessage: "ms-seller-aliases-history-message",
            diff: "ms-seller-aliases-diff",
        },
        burnup: {
            root: "ms-burnup",
            kpis: "ms-burnup-kpis",
            chart: "ms-burnup-chart",
            granularity: "ms-burnup-granularity",
            controls: "ms-burnup-controls",
            analysis: "ms-burnup-analysis",
            scatter: "ms-burnup-scatter",
            staircase: "ms-burnup-staircase",
            table: "ms-burnup-table",
            filters: "ms-burnup-filters",
        },
        diagnostics: {
            root: "ms-diagnostics",
            overviewTab: "ms-diag-overview-tab",
            breakdownTab: "ms-diag-breakdown-tab",
            kpis: "ms-diag-kpis",
            fieldReasonExpand: "ms-diag-field-reason-expand",
            fieldReasonPanel: "ms-diag-field-reason-panel",
            certs: "ms-diag-certs",
            groups: "ms-diag-groups",
            filters: "ms-diag-filters",
            from: "ms-diag-from",
            to: "ms-diag-to",
            accounts: "ms-diag-accounts",
            forms: "ms-diag-forms",
            apply: "ms-diag-apply",
            clearFilters: "ms-diag-clear-filters",
            clearViewFilters: "ms-diag-clear-view-filters",
            agreementCell: "ms-diag-agreement-cell",
            outcome: "ms-diag-outcome",
            issueType: "ms-diag-issue-type",
            reasonMismatchMode: "ms-diag-reason-mismatch-mode",
            groupFormAccount: "ms-diag-group-form-account",
            groupAccountForm: "ms-diag-group-account-form",
            groupForm: "ms-diag-group-form",
            groupAccount: "ms-diag-group-account",
            groupExpand: "ms-diag-group-expand",
            groupExpandPanel: "ms-diag-group-expand-panel",
            groupColumns: "ms-diag-group-columns",
            pagination: "ms-diag-pagination",
            groupsPagination: "ms-diag-groups-pagination",
            showTotalsRow: "ms-diag-show-totals-row",
            totalsRow: "ms-diag-totals-row",
            drillScope: "ms-diag-drill-scope",
            scanCapped: "ms-diag-scan-capped",
            metric: "ms-diag-metric",
            groupCount: "ms-diag-group-count",
        },
    },
    review: {
        certificateHeading: "review-certificateHeading",
        certificateFilename: "review-certificateFilename",
        exmptPercentInput: "review-exmptPercent-input",
        exmptPercentLabel: "review-exmptPercent-label",
        avsBanner: {
            success: "review-avsBanner-success",
            reviewRequired: "review-avsBanner-reviewRequired",
            missingFields: "review-avsBanner-missingFields",
            missingField: "review-avsBanner-missingField",
            multipleMissingFields: "review-avsBanner-multipleMissingFields",
            multipleIssues: "review-avsBanner-multipleIssues",
            invalidTaxId: "review-avsBanner-invalidTaxId",
            error: "review-avsBanner-error",
            mismatch: "review-avsBanner-mismatch",
        },
        customerSuggestions: {
            container: "review-customerSuggestions-container",
            chip: "review-customerSuggestions-chip",
            showMore: "review-customerSuggestions-showMore",
            dialog: "review-customerSuggestions-dialog",
            filter: "review-customerSuggestions-filter",
            count: "review-customerSuggestions-count",
            option: "review-customerSuggestions-option",
            close: "review-customerSuggestions-close",
        },
        avsScannerDialog: {
            container: "review-avsScannerDialog-container",
            header: "review-avsScannerDialog-header",
            body: "review-avsScannerDialog-body",
            skipButton: "review-avsScannerDialog-skipButton",
            footer: "review-avsScannerDialog-footer",
        },
        revalidate: {
            button: "review-revalidate-button",
            dialog: "revalidate-confirm-dialog",
            cancelButton: "revalidate-cancel-button",
            confirmButton: "revalidate-confirm-button",
        },
    },
    campaign: {
        createRequest: {
            spamTemplateAlert: "campaign-create-request-spam-template-alert",
            notScannedTemplateAlert: "campaign-create-request-not-scanned-template-alert",
            spamHint: "campaign-create-request-spam-hint",
        },
        bulkRequests: {
            request: "campaign-bulkRequests-request",
            loader: "campaign-bulkRequests-loader",
            grid: "campaign-bulkRequests-grid",
            pagination: "campaign-bulkRequests-pagination",
        },
        requestDetails: {
            backButton: "campaign-requestDetails-backButton",
            searchBar: "campaign-requestDetails-searchBar",
            export: "campaign-requestDetails-export",
            grid: "campaign-requestDetails-grid",
            loader: "campaign-requestDetails-loader",
            pagination: "campaign-requestDetails-pagination",
            editButton: "campaign-requestDetails-editButton",
            cancelButton: "campaign-requestDetails-cancelButton",
            saveButton: "campaign-requestDetails-saveButton",
            deleteButton: "campaign-requestDetails-deleteButton",
            addRoundDialog: "campaign-requestDetails-addRoundDialog",
            addRoundDialogSendDate: "campaign-requestDetails-addRoundDialogSendDate",
            addRoundDialogReturnDate: "campaign-requestDetails-addRoundDialogReturnDate",
            addRoundDialogDeliveryMethod: "campaign-requestDetails-addRoundDialogDeliveryMethod",
            addRoundButton: "campaign-requestDetails-addRoundButton",
            deliveryMethodLabel: "campaign-requestDetails-deliveryMethodLabel",
            spamTemplateAlert: "campaign-request-details-spam-template-alert",
            addRoundSpamTemplateAlert: "campaign-add-round-spam-template-alert",
        },
        singleRequests: {
            request: "campaign-singleRequests-request",
            searchBar: "campaign-singleRequests-searchBar",
            loader: "campaign-singleRequests-loader",
            grid: "campaign-singleRequests-grid",
            pagination: "campaign-singleRequests-pagination",
            spamTemplateAlert: "campaign-single-request-spam-template-alert",
        },
    },
    customerSearch: {
        heading: "customerSearch-heading",
        switchToJobs: "customerSearch-switchToJobs",
        reports: "customerSearch-reports",
        filtersButton: "customerSearch-filtersButton",
        searchBar: "customerSearch-searchBar",
        manageColumns: "customerSearch-manageColumns",
        moreActions: {
            button: "customerSearch-moreActions-button",
            dropdown: "customerSearch-moreActions-dropdown",
            import: "customerSearch-moreActions-import",
            export: "customerSearch-moreActions-export",
            save: "customerSearch-moreActions-save",
            delete: "customerSearch-moreActions-delete",
            updateLabels: "customerSearch-moreActions-updateLabels",
        },
        requestCertificates: "customerSearch-requestCertificates",
        addCustomerButton: "customerSearch-addCustomerButton",
        filtersPanel: {
            container: "customerSearch-filtersPanel-container",
            viewSavedReports: "customerSearch-filtersPanel-viewSavedReports",
            selectCompanyGroups: "customerSearch-filtersPanel-selectCompanyGroups",
            otherFilters: "customerSearch-filtersPanel-otherFilters",
            exemptionOverrideToggle: "customerSearch-filtersPanel-exemptionOverrideToggle",
            exemptionOverrideSection: "customerSearch-filtersPanel-exemptionOverrideSection",
        },
        grid: "customerSearch-grid",
        pagination: "customerSearch-pagination",
        loader: "customerSearch-loader",
    },
    vendorSearch: {
        heading: "vendorSearch-heading",
        reports: "vendorSearch-reports",
        filtersButton: "vendorSearch-filtersButton",
        searchBar: "vendorSearch-searchBar",
        manageColumns: "vendorSearch-manageColumns",
        moreActions: {
            button: "vendorSearch-moreActions-button",
            dropdown: "vendorSearch-moreActions-dropdown",
            import: "vendorSearch-moreActions-import",
            export: "vendorSearch-moreActions-export",
            save: "vendorSearch-moreActions-save",
        },
        addVendorButton: "vendorSearch-addVendorButton",
        filtersPanel: {
            container: "vendorSearch-filtersPanel-container",
            viewSavedReports: "vendorSearch-filtersPanel-viewSavedReports",
            otherFilters: "vendorSearch-filtersPanel-otherFilters",
        },
        grid: "vendorSearch-grid",
        pagination: "vendorSearch-pagination",
        loader: "vendorSearch-loader",
    },
    jobSearch: {
        heading: "jobSearch-heading",
        searchBar: "jobSearch-searchBar",
        createJobButton: "jobSearch-createJobButton",
        grid: "jobSearch-grid",
        pagination: "jobSearch-pagination",
        loader: "jobSearch-loader",
    },
    certificateSearch: {
        heading: "certificateSearch-heading",
        reports: "certificateSearch-reports",
        filtersButton: "certificateSearch-filtersButton",
        searchBar: "certificateSearch-searchBar",
        manageColumns: "certificateSearch-manageColumns",
        moreActions: {
            button: "certificateSearch-moreActions-button",
            dropdown: "certificateSearch-moreActions-dropdown",
            addCertificate: "certificateSearch-moreActions-addCertificate",
            import: "certificateSearch-moreActions-import",
            export: "certificateSearch-moreActions-export",
            save: "certificateSearch-moreActions-save",
            exportImages: "certificateSearch-moreActions-exportImages",
            delete: "certificateSearch-moreActions-delete",
            update: "certificateSearch-moreActions-update",
            resync: "certificateSearch-moreActions-resync",
        },
        requestCertificates: "certificateSearch-requestCertificates",
        filtersPanel: {
            container: "certificateSearch-filtersPanel-container",
            viewSavedReports: "certificateSearch-filtersPanel-viewSavedReports",
            selectCompanyGroups: "certificateSearch-filtersPanel-selectCompanyGroups",
            otherFilters: "certificateSearch-filtersPanel-otherFilters",
        },
        grid: "certificateSearch-grid",
        pagination: "certificateSearch-pagination",
        loader: "certificateSearch-loader",
        relationshipColumn: {
            cell: "certificateSearch-relationshipColumn-cell",
            link: "certificateSearch-relationshipColumn-link",
            directIcon: "certificateSearch-relationshipColumn-directIcon",
            indirectIcon: "certificateSearch-relationshipColumn-indirectIcon",
        },
        customerSubGrid: {
            table: "certificateSearch-customerSubGrid-table",
            scroll: "certificateSearch-customerSubGrid-scroll",
        },
    },
    pendingCertificateSearch: {
        heading: "pendingCertificateSearch-heading",
        reports: "pendingCertificateSearch-reports",
        filtersButton: "pendingCertificateSearch-filtersButton",
        searchBar: "pendingCertificateSearch-searchBar",
        manageColumns: "pendingCertificateSearch-manageColumns",
        moreActions: {
            button: "pendingCertificateSearch-moreActions-button",
            dropdown: "pendingCertificateSearch-moreActions-dropdown",
            assignCertificate: "pendingCertificateSearch-moreActions-assignCertificate",
            releaseCertificates: "pendingCertificateSearch-moreActions-releaseCertificates",
            delete: "pendingCertificateSearch-moreActions-delete",
            export: "pendingCertificateSearch-moreActions-export",
            exportImages: "pendingCertificateSearch-moreActions-exportImages",
            accept: "pendingCertificateSearch-moreActions-accept",
            save: "pendingCertificateSearch-moreActions-save",
            changeBucket: "pendingCertificateSearch-moreActions-changeBucket",
            changePriority: "pendingCertificateSearch-moreActions-changePriority",
        },
        uploadZip: "pendingCertificateSearch-uploadZip",
        addCertificate: "pendingCertificateSearch-addCertificate",
        filtersPanel: {
            container: "pendingCertificateSearch-filtersPanel-container",
            viewSavedReports: "pendingCertificateSearch-filtersPanel-viewSavedReports",
            assignedTo: "pendingCertificateSearch-filtersPanel-assignedTo",
            escalation: "pendingCertificateSearch-filtersPanel-escalation",
            certificateImagePresent:
                "pendingCertificateSearch-filtersPanel-certificateImagePresent",
            buckets: "pendingCertificateSearch-filtersPanel-buckets",
            location: "pendingCertificateSearch-filtersPanel-location",
        },
        grid: "pendingCertificateSearch-grid",
        pagination: "pendingCertificateSearch-pagination",
        loader: "pendingCertificateSearch-loader",
    },
    vendorCertificateSearch: {
        heading: "vendorCertificateSearch-heading",
        tabs: "vendorCertificateSearch-tabs",
        certificateSearch: {
            reports: "vendorCertificateSearch-certificateSearch-reports",
            filtersButton: "vendorCertificateSearch-certificateSearch-filtersButton",
            searchBar: "vendorCertificateSearch-certificateSearch-searchBar",
            manageColumns: "vendorCertificateSearch-certificateSearch-manageColumns",
            moreActions: {
                button: "vendorCertificateSearch-certificateSearch-moreActions-button",
                dropdown: "vendorCertificateSearch-certificateSearch-moreActions-dropdown",
                save: "vendorCertificateSearch-certificateSearch-moreActions-save",
                export: "vendorCertificateSearch-certificateSearch-moreActions-export",
            },
            showOnlyActiveCertificates:
                "vendorCertificateSearch-certificateSearch-showOnlyActiveCertificates",
            filtersPanel: {
                container: "vendorCertificateSearch-certificateSearch-filtersPanel-container",
                viewSavedReports:
                    "vendorCertificateSearch-certificateSearch-filtersPanel-viewSavedReports",
                otherFilters: "vendorCertificateSearch-certificateSearch-filtersPanel-otherFilters",
            },
            grid: "vendorCertificateSearch-certificateSearch-grid",
            pagination: "vendorCertificateSearch-certificateSearch-pagination",
            loader: "vendorCertificateSearch-certificateSearch-loader",
        },
        certificatePackages: {
            searchBar: "vendorCertificateSearch-certificatePackages-searchBar",
            createPackage: "vendorCertificateSearch-certificatePackages-createPackage",
            grid: "vendorCertificateSearch-certificatePackages-grid",
            pagination: "vendorCertificateSearch-certificatePackages-pagination",
            loader: "vendorCertificateSearch-certificatePackages-loader",
            noData: "vendorCertificateSearch-certificatePackages-noData",
        },
    },
    generalSettings: {
        uploadLogoButton: "upload-logo-button",
        logoFileInput: "logo-file-input",
        companyLogoImage: "company-logo-image",
        supportedFormatsText: "supported-formats-text",
        previewLogoButton: "preview-logo-button",
        logoPreviewDialog: "logo-preview-dialog",
        logoPreviewImage: "logo-preview-image",
        removeLogoButton: "remove-logo-button",
        deleteLogoDialog: "delete-logo-dialog",
        confirmDeleteLogoButton: "confirm-delete-logo-button",
        cancelDeleteLogoButton: "cancel-delete-logo-button",
        enableMultiTaxCheckbox: "enable-multi-tax-checkbox",
        enableMultiTaxLabel: "enable-multi-tax-label",
        disableSettingWarningDialog: "disable-setting-warning-dialog",
        confirmDisableSettingButton: "confirm-disable-setting-button",
        cancelDisableSettingButton: "cancel-disable-setting-button",
        enableLocalJurisdictionCheckbox: "enable-local-jurisdiction-checkbox",
        enableLocalJurisdictionLabel: "enable-local-jurisdiction-label",
        enableAIValidationCheckbox: "enable-ai-validation-checkbox",
        enableAIValidationLabel: "enable-ai-validation-label",
        enableValidNotificationCheckbox: "enable-valid-notification-checkbox",
        enableValidNotificationLabel: "enable-valid-notification-label",
        enableInvalidNotificationCheckbox: "enable-invalid-notification-checkbox",
        enableInvalidNotificationLabel: "enable-invalid-notification-label",
        enableOverridesCheckbox: "enable-overrides-checkbox",
        enableOverridesLabel: "enable-overrides-label",
        useCertPercentagesCheckbox: "use-cert-percentages-checkbox",
        useCertPercentagesLabel: "use-cert-percentages-label",
        outgoingEmailValidationHeading: "outgoing-email-validation-heading",
        allowUnsafeTemplateEmailSendCheckbox: "allow-unsafe-template-email-send-checkbox",
        allowUnsafeTemplateEmailSendLabel: "allow-unsafe-template-email-send-label",
    },
    templates: {
        import: {
            heading: "templates-import-heading",
            templateSelector: "templates-import-templateSelector",
            downloadButton: "templates-import-downloadButton",
            uploadArea: "templates-import-uploadArea",
            guidelines: "templates-import-guidelines",
            helpLink: "templates-import-helpLink",
            errorMessage: "templates-import-errorMessage",
            successMessage: "templates-import-successMessage",
            fileInput: "templates-import-fileInput",
            templateDescription: "templates-import-templateDescription",
        },
        customer: {
            basicTemplate: "templates-customer-basicTemplate",
            billToShipToTemplate: "templates-customer-billToShipToTemplate",
            numberChangeTemplate: "templates-customer-numberChangeTemplate",
        },
        vendor: {
            standardTemplate: "templates-vendor-standardTemplate",
            downloadLink: "templates-vendor-downloadLink",
        },
    },
    languageSupportDialog: {
        container: "language-support-dialog",
    },
    shared: {
        resources: {
            heading: "shared-resources-heading",
            description: "shared-resources-description",
            subHeading: "shared-resources-subHeading",
            tiles: {
                taxAnswers: "shared-resources-taxAnswers",
                taxLaws: "shared-resources-taxLaws",
                exemptEntities: "shared-resources-exemptEntities",
                certificateForms: "shared-resources-certificateForms",
                avalaraUniversity: "shared-resources-avalaraUniversity",
            },
            learnMore: "shared-resources-learnMore",
        },
        customerQuickSearch: "shared-customerQuickSearch",
        recordCount: "shared-recordCount",
        noData: "shared-noData",
        noAccess: "shared-noAccess",
        navigation: "shared-navigation",
        header: "shared-header",
        backButton: "back-button",
        pageInfo: "page-info",
        countryLabel: "lbl-country",
        selectCountry: "select-country",
        commentsTab: "shared-commentsTab",
        changeBucketDialog: {
            container: "shared-changeBucketDialog-container",
            select: "shared-changeBucketDialog-select",
            apply: "shared-changeBucketDialog-apply",
            cancel: "shared-changeBucketDialog-cancel",
        },
        changePriorityDialog: {
            container: "shared-changePriorityDialog-container",
            select: "shared-changePriorityDialog-select",
            apply: "shared-changePriorityDialog-apply",
            cancel: "shared-changePriorityDialog-cancel",
        },
        certificateLabel: {
            select: "shared-certificateLabel-select",
        },
        customerLabel: {
            select: "shared-customerLabel-select",
        },
        certificateLabelFilter: {
            include: "shared-certificateLabelFilter-include",
        },
        customerLabelFilter: {
            include: "shared-customerLabelFilter-include",
        },
        selectExposureZone: {
            selectAllButton: "shared-selectExposureZone-selectAllButton",
        },
        invalidReasonsFilter: "shared-invalidReasonsFilter",
        supportingDocumentsPreview: {
            container: "shared-supportingDocumentsPreview-container",
            cancelButton: "shared-supportingDocumentsPreview-cancelButton",
        },
    },
    certificateSettings: {
        autoScanCheckbox: "cert-settings-auto-scan-checkbox",
        autoScanLabel: "cert-settings-auto-scan-label",
        enableAIValidationCheckbox: "cert-settings-ai-validation-checkbox",
        enableAIValidationLabel: "cert-settings-ai-validation-label",
        requireCertImageCheckbox: "cert-settings-require-cert-image-checkbox",
        requireCertImageLabel: "cert-settings-require-cert-image-label",
        certExpressAutoValidCheckbox: "cert-settings-certexpress-auto-valid-checkbox",
        certExpressAutoValidLabel: "cert-settings-certexpress-auto-valid-label",
        requireTaxPayerIdCheckbox: "cert-settings-require-taxpayer-id-checkbox",
        requireTaxPayerIdLabel: "cert-settings-require-taxpayer-id-label",
        requireTaxPayerIdSstMessage: "cert-settings-require-taxpayer-id-sst-message",
        prefillEffectiveDateCheckbox: "cert-settings-prefill-effective-date-checkbox",
        prefillEffectiveDateLabel: "cert-settings-prefill-effective-date-label",
        useCertPercentagesCheckbox: "cert-settings-use-cert-percentages-checkbox",
        useCertPercentagesLabel: "cert-settings-use-cert-percentages-label",
        removeExtraRegionsCheckbox: "cert-settings-remove-extra-regions-checkbox",
        removeExtraRegionsLabel: "cert-settings-remove-extra-regions-label",
        duplicateCertificateCheckCheckbox: "cert-settings-duplicate-certificate-check-checkbox",
        duplicateCertificateCheckLabel: "cert-settings-duplicate-certificate-check-label",
        saveButton: "cert-settings-save-button",
    },
    duplicateCertificate: {
        dialog: "duplicate-certificate-dialog",
        summary: "duplicate-certificate-summary",
        list: "duplicate-certificate-list",
        link: "duplicate-certificate-link",
        status: "duplicate-certificate-status",
        loadingMore: "duplicate-certificate-loading-more",
        remaining: "duplicate-certificate-remaining",
        matchTooltipTrigger: "duplicate-certificate-match-trigger",
        matchTooltipContent: "duplicate-certificate-match-content",
        confirm: "duplicate-certificate-confirm",
        cancel: "duplicate-certificate-cancel",
    },
    settings: {
        /** Main h1 on the settings layout (Exemption certificates) */
        pageHeading: "settings-page-heading",
        advancedSettings: {
            manageInvalidReasonsLink: "settings-manage-invalid-reasons-link",
            manageLabelsLink: "settings-manage-labels-link",
        },
        labels: {
            certificatesTab: "settings-labels-certificates-tab",
            customersTab: "settings-labels-customers-tab",
            certificates: {
                searchInput: "certificate-labels-search-input",
                addButton: "certificate-labels-add-button",
                table: "certificate-labels-table",
                pagination: "certificate-labels-pagination",
                noData: "certificate-labels-no-data",
                dialog: "certificate-labels-dialog",
                nameInput: "certificate-labels-name-input",
                descriptionInput: "certificate-labels-description-input",
                saveButton: "certificate-labels-save-button",
                cancelButton: "certificate-labels-cancel-button",
                deleteDialog: "certificate-labels-delete-dialog",
                deleteConfirmButton: "certificate-labels-delete-confirm-button",
                deleteCancelButton: "certificate-labels-delete-cancel-button",
                deleteBackButton: "certificate-labels-delete-back-button",
                successToast: "label-success-toast",
                updateToast: "certificate-label-success-toast",
                deleteToast: "deleteCertificateLabelToast",
                row: (id: number | string) => `certificate-labels-row-${id}`,
                editButton: (id: number | string) => `certificate-labels-edit-${id}`,
                deleteButton: (id: number | string) => `certificate-labels-delete-${id}`,
            },
            customers: {
                searchInput: "customer-labels-search-input",
                addButton: "customer-labels-add-button",
                table: "customer-labels-table",
                pagination: "customer-labels-pagination",
                noData: "customer-labels-no-data",
                dialog: "customer-labels-dialog",
                nameInput: "customer-labels-name-input",
                descriptionInput: "customer-labels-description-input",
                saveButton: "customer-labels-save-button",
                cancelButton: "customer-labels-cancel-button",
                deleteDialog: "customer-labels-delete-dialog",
                deleteConfirmButton: "customer-labels-delete-confirm-button",
                deleteCancelButton: "customer-labels-delete-cancel-button",
                deleteBackButton: "customer-labels-delete-back-button",
                successToast: "label-success-toast",
                updateToast: "customer-label-success-toast",
                deleteToast: "deleteCustomerToast",
                row: (id: number | string) => `customer-labels-row-${id}`,
                editButton: (id: number | string) => `customer-labels-edit-${id}`,
                deleteButton: (id: number | string) => `customer-labels-delete-${id}`,
            },
        },
        invalidReasons: {
            searchInput: "invalid-reasons-search-input",
            table: "invalid-reasons-table",
            pagination: "invalid-reasons-pagination",
            noData: "invalid-reasons-no-data",
            dialog: "invalid-reasons-dialog",
            nameInput: "invalid-reasons-name-input",
            descriptionInput: "invalid-reasons-description-input",
            saveButton: "invalid-reasons-save-button",
            cancelButton: "invalid-reasons-cancel-button",
            deleteDialog: "invalid-reasons-delete-dialog",
            deleteConfirmButton: "invalid-reasons-delete-confirm-button",
            deleteCancelButton: "invalid-reasons-delete-cancel-button",
            successToast: "invalid-reason-success-toast",
            deleteToast: "deleteInvalidReasonToast",
            row: (id: number | string) => `invalid-reasons-row-${id}`,
            editButton: (id: number | string) => `invalid-reasons-edit-${id}`,
            deleteButton: (id: number | string) => `invalid-reasons-delete-${id}`,
            systemCodeCell: (id: number | string) => `invalid-reasons-system-code-${id}`,
        },
        addInvalidReasonButton: "add-invalid-reason-button",
        editFaxEmailButton: "edit-fax-email-button",
        deleteFaxEmailButton: "delete-fax-email-button",
        certExpressSettings: {
            notifyInvalidReplacementCheckbox: "notify-invalid-replacement-checkbox",
            invalidReplacementEmail: "invalid-replacement-email-input",
            saveButton: "certexpress-save-button",
        },
        userPreferences: {
            heading: "user-preferences-heading",
            description: "user-preferences-description",
            pendingNotificationCheckbox: "pending-notification-checkbox",
            escalationNotificationCheckbox: "escalation-notification-checkbox",
            validationNotificationCheckbox: "validation-notification-checkbox",
            savePreferencesButton: "save-preferences-button",
            backToSettingsButton: "back-to-settings-button",
        },
        manageExemptionReasons: {
            manageExemptionReasonsDialogs: {
                createUpdateExemptionReason: {
                    exemptReasonName: "exempt-reason-name",
                    exemptReasonDescription: "exempt-reason-desc",
                    entityUseCode: "entity-use-code",
                },
            },
        },
        tabs: {
            certificateRequests: {
                manageTemplatesLink: "manage-templates-link",
                manageFaxEmails: {
                    addEditFaxEmailDialog: {
                        addEditFaxEmailDialog: "add-edit-fax-email-dialog",
                    },
                    deleteFaxEmailDialog: { deleteFaxEmailDialog: "delete-fx-email-dialog" },
                },
            },
        },
    },
    missingCertificatesReport: {
        reportTypeSelector: "missingCertificatesReport-reportTypeSelector",
        filters: {
            container: "missingCertificatesReport-filters-container",
            customerCode: "missingCertificatesReport-filters-customerCode",
            customerName: "missingCertificatesReport-filters-customerName",
            customerState: "missingCertificatesReport-filters-customerState",
            exposureZone: "missingCertificatesReport-filters-exposureZone",
            customerRelationship: "missingCertificatesReport-filters-customerRelationship",
            runReportButton: "missingCertificatesReport-filters-runReportButton",
            emailReportButton: "missingCertificatesReport-filters-emailReportButton",
            exportReportButton: "missingCertificatesReport-filters-exportReportButton",
        },
        grid: "missingCertificatesReport-grid",
        pagination: "missingCertificatesReport-pagination",
        loader: "missingCertificatesReport-loader",
        recordCount: "missingCertificatesReport-recordCount",
        noData: "missingCertificatesReport-noData",
        exportDialog: {
            container: "missingCertificatesReport-exportDialog-container",
            titleInput: "missingCertificatesReport-exportDialog-titleInput",
            exportButton: "missingCertificatesReport-exportDialog-exportButton",
            cancelButton: "missingCertificatesReport-exportDialog-cancelButton",
        },
        scheduleDialog: {
            container: "missingCertificatesReport-scheduleDialog-container",
            scheduleButton: "missingCertificatesReport-scheduleDialog-scheduleButton",
            cancelButton: "missingCertificatesReport-scheduleDialog-cancelButton",
        },
    },
    billToShipToReport: {
        reportTypeSelector: "billToShipToReport-reportTypeSelector",
        filters: {
            container: "billToShipToReport-filters-container",
            customerName: "billToShipToReport-filters-customerName",
            customerCode: "billToShipToReport-filters-customerCode",
            billToRegion: "billToShipToReport-filters-billToRegion",
            shipToRegion: "billToShipToReport-filters-shipToRegion",
            runReportButton: "billToShipToReport-filters-runReportButton",
            exportReportButton: "billToShipToReport-filters-exportReportButton",
        },
        grid: "billToShipToReport-grid",
        billToCodeLink: "billToShipToReport-billToCodeLink",
        subGrid: {
            scroll: "billToShipToReport-subGrid-scroll",
            table: "billToShipToReport-subGrid-table",
            shipToCodeLink: "billToShipToReport-subGrid-shipToCodeLink",
        },
        pagination: "billToShipToReport-pagination",
        loader: "billToShipToReport-loader",
        recordCount: "billToShipToReport-recordCount",
        noData: "billToShipToReport-noData",
        exportDialog: {
            container: "billToShipToReport-exportDialog-container",
            titleInput: "billToShipToReport-exportDialog-titleInput",
            exportButton: "billToShipToReport-exportDialog-exportButton",
            cancelButton: "billToShipToReport-exportDialog-cancelButton",
        },
    },
    bouncedEmailReport: {
        filters: {
            container: "bouncedEmailReport-filters-container",
            toggleButton: "bouncedEmailReport-filters-toggleButton",
            panel: "bouncedEmailReport-filters-panel",
            searchText: "bouncedEmailReport-filters-searchText",
            startDate: "bouncedEmailReport-filters-startDate",
            endDate: "bouncedEmailReport-filters-endDate",
            emailSource: "bouncedEmailReport-filters-emailSource",
            deliveryStatus: "bouncedEmailReport-filters-deliveryStatus",
            reason: "bouncedEmailReport-filters-reason",
            runReportButton: "bouncedEmailReport-filters-runReportButton",
            dateRangeError: "bouncedEmailReport-filters-dateRangeError",
        },
        grid: "bouncedEmailReport-grid",
        pagination: "bouncedEmailReport-pagination",
        loader: "bouncedEmailReport-loader",
        recordCount: "bouncedEmailReport-recordCount",
        noData: "bouncedEmailReport-noData",
    },
    customerComments: {
        container: "customerComments-container",
        addButton: "customerComments-addButton",
        commentsList: "customerComments-commentsList",
        noComments: "customerComments-noComments",
        commentItem: "customerComments-commentItem",
        commentText: "customerComments-commentText",
        commentAuthor: "customerComments-commentAuthor",
        commentTimestamp: "customerComments-commentTimestamp",
        editButton: "customerComments-editButton",
        deleteButton: "customerComments-deleteButton",
        dialog: {
            container: "customerComments-dialog-container",
            heading: "customerComments-dialog-heading",
            textArea: "customerComments-dialog-textArea",
            saveButton: "customerComments-dialog-saveButton",
            cancelButton: "customerComments-dialog-cancelButton",
            fileInput: "customerComments-dialog-fileInput",
        },
        deleteDialog: {
            container: "customerComments-deleteDialog-container",
        },
    },
    coverLetter: {
        spamTemplateAlert: "cover-letter-spam-template-alert",
        notScannedTemplateAlert: "cover-letter-not-scanned-template-alert",
        scanLink: "cover-letter-scan-link",
        scanButton: "cover-letter-scan-button",
        spamHint: "cover-letter-spam-hint",
        manageTemplatesHeading: "cover-letter-manage-templates-heading",
        titleInput: "cover-letter-title-input",
        subjectInput: "cover-letter-subject-input",
        descriptionInput: "cover-letter-description-input",
        templateLink: "cover-letter-template-link",
        validateAndSaveButton: "cover-letter-validate-and-save-button",
        saveButton: "cover-letter-save-button",
        validateDialog: {
            updateCoverLetterButton: "cover-letter-dialog-update-button",
            saveWithoutUpdatingButton: "cover-letter-dialog-save-without-updating-button",
        },
    },
    vendorRequest: {
        scanResultTag: "vendor-request-scan-result-tag",
        scanAllTemplatesLink: "vendor-request-scan-all-templates-link",
        spamTemplateAlert: "vendor-request-spam-template-alert",
        notScannedTemplateAlert: "vendor-request-not-scanned-template-alert",
        spamHint: "vendor-request-spam-hint",
        finishButton: "vendor-request-finish-button",
    },
    vendorPackages: {
        sendPackage: {
            scanResultTag: "vendor-packages-send-package-scan-result-tag",
            scanAllTemplatesLink: "vendor-packages-send-package-scan-all-templates-link",
            spamTemplateAlert: "vendor-packages-send-package-spam-template-alert",
            notScannedTemplateAlert: "vendor-packages-send-package-not-scanned-template-alert",
            sendButton: "vendor-packages-send-package-send-button",
            spamHint: "vendor-packages-send-package-spam-hint",
        },
    },
    job: {
        container: "job-container",
        form: "job-form",
        jobCode: "job-jobCode",
        jobName: "job-jobName",
        region: "job-region",
        createButton: "job-createButton",
        cancelButton: "job-cancelButton",
        addPhaseButton: "job-addPhaseButton",
        phases: {
            container: "job-phases-container",
            phaseContainer: "job-phase-container",
            phaseCode: "job-phase-phaseCode",
            phaseName: "job-phase-phaseName",
            deletePhaseButton: "job-phase-deleteButton",
            collapseButton: "job-phase-collapseButton",
            addTaskButton: "job-phase-addTaskButton",
            tasks: {
                container: "job-tasks-container",
                taskContainer: "job-task-container",
                taskCode: "job-task-taskCode",
                taskName: "job-task-taskName",
                deleteTaskButton: "job-task-deleteButton",
            },
        },
        details: {
            container: "job-details-container",
            certificates: {
                container: "job-details-certificates-container",
                grid: "job-details-certificates-grid",
                pagination: "job-details-certificates-pagination",
                loader: "job-details-certificates-loader",
                noData: "job-details-certificates-noData",
                unlinkButton: "job-details-certificates-unlinkButton",
            },
            customFields: {
                container: "job-details-customFields-container",
                grid: "job-details-customFields-grid",
                tab: "tabpanel-custom-fields",
            },
        },
        unlinkCertificateDialog: {
            container: "job-unlinkCertificateDialog-container",
            unlinkButton: "job-unlinkCertificateDialog-unlinkButton",
            backButton: "job-unlinkCertificateDialog-backButton",
        },
        deleteDialog: {
            container: "job-deleteDialog-container",
            deleteButton: "job-deleteDialog-deleteButton",
            backButton: "job-deleteDialog-backButton",
        },
    },
    ecms: {
        heading: "ecms-heading",
        filtersButton: "ecms-filtersButton",
        grid: "ecms-grid",
        pagination: "ecms-pagination",
        loader: "ecms-loader",
        noData: "ecms-noData",
        customerCodeLink: "ecms-customerCodeLink",
        customerDetailDialog: "ecms-customerDetailDialog",
        certIdLink: "ecms-certIdLink",
        certificateDetailDialog: "ecms-certificateDetailDialog",
        filtersPanel: {
            container: "ecms-filtersPanel-container",
            filters: "ecms-filtersPanel-filters",
            companyId: "ecms-filtersPanel-companyId",
            customerName: "ecms-filtersPanel-customerName",
            customerCode: "ecms-filtersPanel-customerCode",
            avaCertId: "ecms-filtersPanel-avaCertId",
            exemptCertId: "ecms-filtersPanel-exemptCertId",
            country: "ecms-filtersPanel-country",
            region: "ecms-filtersPanel-region",
        },
    },
    jobDetails: {
        container: "jobDetails-container",
        heading: "jobDetails-heading",
        jobsSelect: "jobDetails-jobsSelect",
        phasesSelect: "jobDetails-phasesSelect",
        tasksSelect: "jobDetails-tasksSelect",
    },
    companyGroups: {
        hierarchy: {
            searchInput: "companyGroups-hierarchy-searchInput",
            addButton: "companyGroups-hierarchy-addButton",
            moreMenuTrigger: "companyGroups-hierarchy-moreMenuTrigger",
            moreMenu: {
                move: "companyGroups-hierarchy-moreMenu-move",
                delete: "companyGroups-hierarchy-moreMenu-delete",
            },
            table: "companyGroups-hierarchy-table",
            pagination: "companyGroups-hierarchy-pagination",
            selectAllCheckbox: "companyGroups-hierarchy-selectAllCheckbox",
            collapseAll: "companyGroups-hierarchy-collapseAll",
        },
        groupRow: {
            row: "companyGroups-groupRow-row",
            checkbox: "companyGroups-groupRow-checkbox",
            editButton: "companyGroups-groupRow-editButton",
            moveButton: "companyGroups-groupRow-moveButton",
            deleteButton: "companyGroups-groupRow-deleteButton",
        },
        companyRow: {
            row: "companyGroups-companyRow-row",
            checkbox: "companyGroups-companyRow-checkbox",
            moveButton: "companyGroups-companyRow-moveButton",
            removeButton: "companyGroups-companyRow-removeButton",
        },
        moveGroupDialog: {
            container: "companyGroups-moveGroupDialog-container",
            destinationSelect: "companyGroups-moveGroupDialog-destinationSelect",
            moveButton: "companyGroups-moveGroupDialog-moveButton",
            cancelButton: "companyGroups-moveGroupDialog-cancelButton",
        },
        moveCompanyDialog: {
            container: "companyGroups-moveCompanyDialog-container",
            destinationSelect: "companyGroups-moveCompanyDialog-destinationSelect",
            moveButton: "companyGroups-moveCompanyDialog-moveButton",
            cancelButton: "companyGroups-moveCompanyDialog-cancelButton",
        },
        removeCompanyDialog: {
            container: "companyGroups-removeCompanyDialog-container",
            confirmButton: "companyGroups-removeCompanyDialog-confirmButton",
            cancelButton: "companyGroups-removeCompanyDialog-cancelButton",
        },
    },
};
